<script setup lang="ts">
import { OdsSkeleton } from "@ods/lidl-web-vuejs";
</script>

<template>
  <div class="reco_gridbox-skeleton">
    <OdsSkeleton class="reco_image-skeleton" />
    <OdsSkeleton class="reco_rating-skeleton" />
    <OdsSkeleton class="reco_rating-skeleton reduced" />
    <OdsSkeleton class="reco_name-skeleton" />
    <OdsSkeleton class="reco_name-skeleton reduced" />
    <OdsSkeleton class="reco_price-skeleton" />
  </div>
</template>

<style lang="scss" scoped>
.reco_gridbox-skeleton {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(16, 1fr);
  padding: 16px;
  gap: 8px;

  * {
    border-radius: 4px;
  }

  .reduced {
    width: 66%;
  }
}

.reco_image-skeleton {
  grid-column: span 3;
  grid-row: span 8;
}

.reco_rating-skeleton {
  grid-column: span 1;
  grid-column-start: 1;
  grid-row: span 1;
}

.reco_name-skeleton {
  grid-column: span 3;
  grid-row: span 1;
}

.reco_price-skeleton {
  grid-column: span 1;
  grid-row: span 3;
  grid-row-start: 13;
  grid-row-end: 16;
}
</style>
